<div class="wrapper wrapper-content" *ngIf="isLoaded()">
  <div class="container-fluid p-0">
    <div class="row p-0">
      <div class="col-12">
        <p-panel styleClass="mb-3" [toggleable]="true">
          <p-header>
            <i class="fa fa-filter" aria-hidden="true"></i> {{ 'Filtros' | translate }}
          </p-header>
          <div class="row">
            <div class="col-12 m-b-md">
              <formPlyca #formPlycaRef1 [formConfig]="formConfig1" *ngIf="formConfig1" [manageWaitService]=false>
              </formPlyca>
            </div>
          </div>
        </p-panel>



        <p-panel styleClass="mb-3" [toggleable]="true"
          [collapsed]="(!model || !(model.frameworkAgreement) ||!(model.frameworkAgreement.identifier))">
          <p-header>
            <!--<i class="fa fas fa-lg fa-file-contract"></i> -->
            <span class="cif ml-2">Datos del Acuerdo Marco</span>
          </p-header>
          <ng-container *ngIf="model && model.frameworkAgreement && model.frameworkAgreement.identifier">
            <ng-container *ngTemplateOutlet="frameworkAgreementBasicInfo; context: { model: model }">
            </ng-container>
          </ng-container>
          <p-tabView>
            <p-tabPanel cache="false" header="{{'Adjudicaciones del AM' | translate}}">
              <div class="row">
                <div class="col-12">
                  <span class="m-xst float-right m-l-md leyenda"
                    *ngIf="model && model.filterFrameWorkAgreementContractList && model.totalAwards > 0">
                    {{ 'General.showing' | translate }}
                    {{ model.filterFrameWorkAgreementContractList.length }}
                    {{'General.from'|translate}}
                    {{ ' de ' | translate }} {{ model.totalAwards }} </span>
                </div>
              </div>
              <div>
                <div class="alert alert-info col-12" role="alert"
                  *ngIf="!model.filterFrameWorkAgreementContractList || model.filterFrameWorkAgreementContractList.length===0">
                  <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>{{
                    'General.noData' | translate }}</span>
                </div>
                <p-table
                  *ngIf="model.filterFrameWorkAgreementContractList && model.filterFrameWorkAgreementContractList.length>0"
                  [responsive]="true" sortField="columns['CONTRATOID']?.value"
                  [value]="model.filterFrameWorkAgreementContractList" sortOrder="1" [paginator]="false">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 10%">{{'frameworkAgreementSituation.awardId'|translate}}</th>
                      <th style="width: 25%">{{'frameworkAgreementSituation.award'|translate}}</th>
                      <th>{{'frameworkAgreementSituation.awardDate'|translate}}</th>
                      <th style="width: 25%">{{'frameworkAgreementSituation.awardDescripcion'|translate}}</th>
                      <th>{{'frameworkAgreementSituation.awardExpiredDate'|translate}}</th>
                      <th>{{'frameworkAgreementSituation.awardLots'|translate}}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-element let-idx="rowIndex">
                    <tr>
                      <td><span
                          class="p-column-title">{{'frameworkAgreementSituation.awardId'|translate}}</span>{{idx+1}}
                      </td>
                      <td><span
                          class="p-column-title">{{'frameworkAgreementSituation.award'|translate}}</span>{{element.columns['ADJUDICATARIO']?.value}}
                      </td>
                      <td><span
                          class="p-column-title">{{'frameworkAgreementSituation.awardDate'|translate}}</span>{{element.columns['FECHA_ADJ']?.value}}
                      </td>
                      <td><span
                          class="p-column-title">{{'frameworkAgreementSituation.awardDescripcion'|translate}}</span>{{element.columns['CONTRATODESCRIP']?.value}}
                      </td>
                      <td><span
                          class="p-column-title">{{'frameworkAgreementSituation.awardExpiredDate'|translate}}</span>{{element.columns['FECHA_VIGENCIA']?.value}}
                      </td>
                      <td>
                        <span class="p-column-title">
                          {{'frameworkAgreementSituation.awardLots'|translate}}</span>
                        <span #prueba (mouseenter)="loteTooltip.toggle($event)" (mouseleave)="loteTooltip.hide($event)">
                          <span *ngIf="element.columns['LOTES']?.value"><span>Lote</span><span>
                              {{element.columns['LOTES']?.value}}</span>
                          </span>
                          <span *ngIf="!element.columns['LOTES']?.value">Sin Lotes</span>
                        </span>
                        <p-overlayPanel #loteTooltip appendTo="prueba" [style]="{ 'max-width': '20%'}">
                          <dl class="row">
                            <dd class="col-12">
                              {{(element.columns['LOTE_DESC']?.value)?element.columns['LOTE_DESC']?.value:'Sin
                              Lotes'}}</dd>
                          </dl>
                        </p-overlayPanel>
                      </td>
                      <td class="text-right">
                        <div class="btn-group">
                          <button [attr.disabled]="(!element.newBasedContractEnabled)?'disabled': null"
                            class="btn btn-outline-secondary btn-sm t-action-button"
                            (click)="this.createBasedContract(element)"
                            title="{{ 'Iniciar Contrato Basado en AM' | translate}}">
                            <i class="fas fa-plus" aria-hidden="true"></i>
                          </button>
                        </div>
                      </td>

                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </p-tabPanel>
            <p-tabPanel cache="false" header="{{'Contratos Basados en AM' | translate}}">
              <div class="row">
                <div class="col-12">
                  <span class="m-xst float-right m-l-md leyenda"
                    *ngIf="model && model.filterFrameWorkAgreementContractList && model.totalBasedContract > 0 && model.award ">
                    {{ 'General.showing' | translate }}
                    {{ model.filterBasedContractList.length }}
                    {{'General.from'|translate}}
                    {{ model.award ? model.totalFilterAwardBasedContract : model.totalBasedContract }}
                    {{ ' Contratos Basados en la adjudicación del AM. ' | translate }}</span>
                </div>
              </div>
              <div>
                <div class="alert alert-info col-12" role="alert"
                  *ngIf="!model.filterBasedContractList || model.filterBasedContractList.length===0">
                  <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>{{
                    'General.noData' | translate }}</span>
                </div>
                <p-table *ngIf="model.filterBasedContractList && model.filterBasedContractList.length>0"
                  [value]="model.filterBasedContractList" sortField="columns['CONTRATOID']?.value" sortOrder="1"
                  [rows]="10" [paginator]="true" [pageLinks]="4" [rowsPerPageOptions]="[5, 10, 25, 50]">

                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 2%"></th>
                      <th style="width: 12%">{{'frameworkAgreementSituation.basedContractNumber'|translate}}</th>
                      <th style="width: 25%">{{'frameworkAgreementSituation.basedContractTittle'|translate}}</th>
                      <th style="width: 25%">{{'frameworkAgreementSituation.basedContractAward'|translate}}</th>
                      <th>{{'frameworkAgreementSituation.basedContractAwardDate'|translate}}</th>
                      <th>{{'frameworkAgreementSituation.basedContractPrice'|translate}}</th>
                      <th>{{'frameworkAgreementSituation.basedContractStatus'|translate}}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-element let-idx="rowIndex">
                    <tr>
                      <td>
                        {{idx+1}}
                      </td>
                      <td>{{element.columns['EXPEDIENTEID']?.value}}
                      </td>
                      <td>{{element.columns['ALIAS_CBAM']?.value}}
                      </td>
                      <td>{{element.columns['ADJUDICATARIO_CBAM']?.value}}
                      </td>
                      <td>{{element.columns['FECHA_ADJ']?.value}}
                      </td>
                      <td style="text-align: right;width: 120px ">{{element.columns['PRECIO']?.value
                        | currency: 'EUR' }}&nbsp;&nbsp;
                      </td>
                      <td>{{element.columns['ESTADO_CBAM']?.value}}
                      </td>
                      <td class="text-right">
                        <div class="btn-group">
                          <pmenu-actions [identifier]="deNormalizaDossierId(element.columns['PROPUESTA_CBAM']?.value)"
                            [dto]="dossier" [lazy]="true" [dtoType]="PROJECTENTITY"
                            [items]="this.getDossierMenuItemCBAM(element.columns['PROPUESTA_CBAM']?.value)">
                          </pmenu-actions>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </p-tabPanel>
          </p-tabView>
        </p-panel>
      </div>
    </div>
  </div>
</div>

<!-- TEMPLATE PARA LOS DATOS BASICOS DEL CONTRATO -->
<ng-template #frameworkAgreementBasicInfo let-model="model">
  <h2 class="mt-1"></h2>
  <div class="row mt-1">

    <dl class="col-12">


      <dt class="d-inline-block col-12 col-md-3">{{'Acuerdo Marco'| translate}}:</dt>
      <dd class="d-inline-block col-12 col-md-3">
        <span> {{model?.frameworkAgreement?.contractFolderId}}


        </span>
      </dd>

      <dt class="d-inline-block col-12 col-md-3">{{'Propuesta'| translate}}:</dt>
      <dd class="d-inline-block col-12 col-md-3">
        <span>{{model?.dossierId}}</span>
      </dd>

      <dt class="d-inline-block col-12 col-md-3">{{'Título Abreviado' | translate}}:</dt>
      <dd class="d-inline-block col-12 col-md-3">
        <span>{{model?.frameworkAgreement?.abbreviatedTitle}}</span>
      </dd>

      <dt class="d-inline-block col-12 col-md-3">{{'Valor Estimado' | translate}}:</dt>
      <dd class="d-inline-block col-12 col-md-3">
        <span>{{model?.frameworkAgreement?.budget?.estimatedAmount | currency: 'EUR' }}</span>
      </dd>

      <dt class="d-inline-block col-12 col-md-3">{{'Gasto Acumulado de Contratos Basados Adjudicados'|translate}}:</dt>
      <dd class="d-inline-block col-12 col-md-3">
        <span>{{model?.basedContractAccumulatedExpense | currency: 'EUR'}}</span>
      </dd>


      <div class="col-12 text-right" *ngIf="visibleItems">
        <pmenu-actions [identifier]="model?.dossierId" [dto]="dossier" [lazy]="false" [dtoType]="PROJECTENTITY"
          [items]="this.getDossierMenuItemAM(model?.dossierId)">
        </pmenu-actions>
      </div>
    </dl>

  </div>
</ng-template>